import { forwardRef } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames/bind';
import InputError from '../InputError';
import styles from './Checkbox.module.scss';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const cln = classnames.bind(styles);

/**
 * This component accepts all default checkbox props plus additional custom props.
 * It renders checkbox input wrapped in a div tag. If the "label" prop is provided then the input is wrapped in a label tag.
 */
const Checkbox = /*#__PURE__*/forwardRef(function Checkbox({
  checked,
  className,
  disabled = false,
  highlighted = false,
  containerClassName,
  error,
  label,
  onChange = () => {},
  ...rest
}, ref) {
  const Container = label ? 'label' : 'div';
  return (
    /*#__PURE__*/
    // eslint-disable-next-line jsx-a11y/label-has-associated-control,jsx-a11y/label-has-for
    _jsxs(Container, {
      className: cln('Checkbox', containerClassName, {
        checked,
        disabled,
        error,
        highlighted
      }),
      children: [/*#__PURE__*/_jsx("input", {
        type: "checkbox",
        checked: checked,
        value: checked,
        disabled: disabled,
        onChange: onChange,
        className: cln(className, 'input'),
        ref: ref,
        ...rest
      }), label, error && /*#__PURE__*/_jsx(InputError, {
        children: error
      })]
    })
  );
});
Checkbox.propTypes = {
  /** @ignore */
  checked: PropTypes.bool,
  /** @ignore */
  className: PropTypes.string,
  /** Custom class name set on the input container */
  containerClassName: PropTypes.string,
  /** @ignore */
  disabled: PropTypes.bool,
  /** Whether or not the component should be highlighted */
  highlighted: PropTypes.bool,
  /** Error string which should be displayed below the input field */
  error: PropTypes.string,
  /** When provided, renders a label on the right of the checkbox */
  label: PropTypes.string,
  /** @ignore */
  onChange: PropTypes.func
};
export default Checkbox;